"use client";
import { Button, Input, Skeleton, createStyles } from "@mantine/core";
import { ArrowLeft, ArrowRight } from "../Svg";

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#5C5C5C",
    fontWeight: "400",
  },
  button: {
    height: "40px",
    width: "108px",
    alignItems: "center",
  },
  input: {
    textAlign: "center",
    marginRight: "16px",
    height: 32,
  },
}));

const CPaginationWithLinksSkeleton = ({ className }) => {
  const { classes } = useStyles();
  return (
    <section className={`my-8 ${className}`}>
      <div className="flex justify-end">
        <div className="flex flex-wrap items-center">
          <h3 className={`${classes.title} m-0 mr-[16px]`}>
            <Skeleton height={24} width={46} radius={"xl"} />
          </h3>
          <Input
            readOnly
            defaultValue={1}
            style={{
              width: "80px",
              minWidth: `40px`,
              height: "32px",
              marginRight: "16px",
            }}
            classNames={{ input: classes.input }}
          />
          <h3 className={`${classes.title} m-0 mr-[16px]`}>
            <Skeleton height={24} width={32} radius={"xl"} />
          </h3>
          <Button.Group className={`${classes.button}`}>
            <Button
              aria-label={"prev"}
              variant="default"
              className="border-none bg-primaryOpacity hover:bg-primaryOpacity pr-2"
            >
              <ArrowLeft height="13px" width="26px" color="#2BADE3" />
            </Button>
            <Button
              aria-label={"next"}
              variant="default"
              className="border-none bg-primaryOpacity hover:bg-primaryOpacity pl-2"
            >
              <ArrowRight height="13px" width="26px" color="#2BADE3" />
            </Button>
          </Button.Group>
        </div>
      </div>
    </section>
  );
};

export default CPaginationWithLinksSkeleton;
